<template>
    <div class="app-content content px-1 py-2">
        <div class="content-wrapper">
            <backToDashboard></backToDashboard>
            <div class="content-header row mb-2">
                <div class="content-header-left col-md-4 col-12" v-if="userSettings.kind == 'supervisor'">
                    <h2 class="content-header-title mt-4 mb-0 d-inline-block"></h2>
                    <fieldset class="mt-2 form-group position-relative">
                        <select class="form-control" v-on:change="goToSupervisorStatistics">
                            <option selected>Mes statistiques</option>
                            <option>Statistiques agent</option>
                        </select>
                    </fieldset>
                </div>
            </div>
            <div class="content-body">
                <section id="basic-examples">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{CurrentStats.waiting_count}}</h3>
                                                        <h6>Discussions</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{CurrentStats.average_waiting | formatMinutes}}</h3>
                                                        <h6>Temps d'attente moyen</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{CurrentStats.average_running | formatMinutes}}</h3>
                                                        <h6>Temps de traitement moyen</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{CurrentStats.handle_rate}}%</h3>
                                                        <h6>Discussions traitées / Discussions arrivées</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-2 col-lg-6 col-12">
                                    <div class="card pull-up">
                                        <div class="card-content">
                                            <div class="card-body">
                                                <div class="media d-flex">
                                                    <div class="media-body text-left">
                                                        <h3 class="info">{{CurrentStats.closed_count}}</h3>
                                                        <h6>Discussions traités</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class="{'card p-3 loading-state': PendingRequest.get_stats || PendingRequest.get_csv_stats, 'card p-3': !PendingRequest.get_stats}">
                                <loader v-if="PendingRequest.get_stats || PendingRequest.get_csv_stats"></loader>
                                <div class="card-content">
                                    <div class="card-body p-5 text-center">
                                        <div class="row">
                                            <div class="col-md-8 mb-1">
                                                <fieldset class="form-group position-relative">
                                                    <select class="form-control" id="DefaultSelect" v-model="time" v-on:change="getStats">
                                                        <option :selected="true" value="lastweek">Les 7 derniers jours</option>
                                                        <option value="today">Aujourd'hui</option>
                                                        <option value="yesterday">Hier</option>
                                                        <option value="thismonth">Ce mois-ci</option>
                                                    </select>
                                                </fieldset>
                                                <form class="filter-skills text-left">
                                                    <div class="form-check d-inline-block mr-2" v-for="(skill, index) in AllSkills" :key="index + 'skill'">
                                                        <input :id="skill.label" type="checkbox" v-on:change="addOrRemoveSkill(skill.label)" class="form-check-input">
                                                        <label class="form-check-label" :for="skill.label">{{skill.label}}</label>
                                                    </div>
                                                </form>
                                            </div>
                                            <div class="col-md-4 mb-1 text-right">
                                                <button class="btn btn-info  round" v-on:click="getCsvStats">Télécharger</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-10">
                                                <chart :stats="CurrentStats" :skills="skills" :time="time"></chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
import backToDashboard from '../components/layout/backToDashboard'
import Loader from '../views/Loader'
import Chart from '../components/charts/chart.vue'

export default {
  components: {
    'backToDashboard': backToDashboard,
    'loader': Loader,
    'chart': Chart
  },
  data: function () {
    return {
      time: 'lastweek',
      skills: [],
      currentSkill: '',
      details: [],
      loaded: false
    }
  },
  computed: {
    AllSkills () {
      return this.$store.getters.getSkills
    },
    intervalStats () {
      return this.$store.getters.getIntervalsForStats
    },
    userSettings () {
      return this.$store.getters.getOwnSettings
    },
    CurrentStats () {
      return this.$store.getters.getStats
    },
    StatsCsv () {
      return this.$store.getters.getCsvStats
    },
    PendingRequest () {
      return this.$store.getters.getPendingRequests
    }
  },
  methods: {
    addOrRemoveSkill (skill) {
      if (this.skills.indexOf(skill) !== -1) {
        this.skills.splice(this.skills.indexOf(skill), 1)
      } else {
        this.skills.push(skill)
      }
    },
    getAgents (skill) {
      this.currentSkill = skill
      this.$socket.getAgents(skill)
    },
    getStats (agent) {
      this.currentAgent = agent
      this.$store.dispatch('setAgentForGetSupervisorStats', agent)

      this.$socket.getStats(this.time)
    },
    goToSupervisorStatistics () {
      this.$router.push({
        path: '/supervisor-statistics'
      })
    },
    getCsvStats () {
      this.$socket.getCsvStats(this.time)
    },
    changeTime () {
      // eslint-disable-next-line
      this.$socket.getStats(newResponse)
    }
  },
  watch: {
    StatsCsv: function (newResponse, oldResponse) {
      if (newResponse.length) {
        let csvContent = 'data:text/csv;charset=utf-8,'
        csvContent = csvContent + newResponse
        let data = encodeURI(csvContent)
        let filename = this.userSettings.uuid + '.csv'
        let link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        link.click()
      }
    }
  },
  mounted: function () {
    this.$socket.getStats(this.time)
  }
}
</script>
